import React from "react";

export default function InputField(props : React.ComponentPropsWithRef<"input">){
    const {className, ...otherProps} = props;

    return (
        <input className={`input-text ${className}`} {...otherProps} />
    )
}